<template>
  <div class="article-edit-container">
    <div>
      <bread-crumb />
    </div>
    <div class="global-table-container">
      <basic-form
        ref="basicForm"
        :form-data="formData"
      >
        <template #task_name>
          <a-input
            v-decorator="['task_name',{rules: [
              { required: true, message: '请输入任务名称' },
            ],initialValue:data.task_name}]"
            placeholder="请输入任务名称"
          />
        </template>
        <template #task_type>
          <a-radio-group
            v-decorator="['task_type',{rules: [
              { required: true, message: '请选择任务类型' },
            ],initialValue:data.task_type}]"
            placeholder="请选择任务类型"
            :disabled="disabledTaskType"
            @change="changeTaskType"
          >
            <a-radio
              v-for="item in typeData"
              :key="item.id"
              :value="item.id"
            >
              {{ item.name }}
            </a-radio>
          </a-radio-group>
        </template>
        <template #task_speaker>
          <a-input
            v-decorator="['task_speaker',{rules: [
              { required: false, message: '请输入主讲人' },
            ],initialValue:data.task_speaker}]"
            placeholder="请输入主讲人"
          />
        </template>
        <template #company_id>
          <a-select
            v-decorator="['company_id',{rules: [
              { required: true, message: '请选择药企' },
            ],initialValue:data.company_id}]"
            placeholder="请选择药企"
            :disabled="isCompanyDisabled"
            @change="handleChangeCompany"
          >
            <a-select-option
              v-for="item in companyData"
              :key="item.id"
              :value="item.id"
            >
              {{ item.name }}
            </a-select-option>
          </a-select>
        </template>
        <template #admin_id>
          <a-select
            v-decorator="['admin_id',{rules: [
              { required: true, message: '请选择发布者' },
            ],initialValue:data.admin_id}]"
            placeholder="请选择发布者"
            :disabled="isDisabled"
            @change="changeAdmin"
          >
            <a-select-option
              v-for="item in adminData"
              :key="item.id"
              :value="item.id"
            >
              {{ item.real_name }}
            </a-select-option>
          </a-select>
        </template>
        <template #promoters>
          <a-tree-select
            v-decorator="['promoters',{rules: [
              { required: true, message: '请选择推广员' },
            ],initialValue:data.promoters}]"
            style="width: 100%"
            :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
            multiple
            :tree-data="promotersData"
            tree-checkable
            :disabled="isDisabledPromoter"
            tree-default-expand-all
            tree-node-filter-prop="title"
          />
        </template>
        <template #datas>
          <a-select
            v-decorator="['datas',{rules: [
              { required: true, message: '请选择素材' },
            ],initialValue:data.datas}]"
            placeholder="请选择素材"
            :disabled="isDisabled"
            :mode="selectMode"
            show-search
            :filter-option="filterOption"
            @change="onChangeResource"
          >
            <a-select-option
              v-for="item in resourceData"
              :key="item.id"
            >
              {{ item.name }}
            </a-select-option>
          </a-select>
        </template>
        <template #meet>
          <a-radio-group
            v-decorator="['meet',{rules: [
              { required: false, },
            ],initialValue:meet}]"
            class="meeting"
            @change="onChangeMeet"
          >
            <a-radio :value="0">
              <div class="meeting-text">
                无
              </div>
            </a-radio>
            <a-radio :value="1">
              <div class="meeting-text">
                科室会会后调研
              </div>
              <div
                :class="{'has-error':isReportError}"
                class="meeting-select"
              >
                <a-select
                  v-decorator="['after_survey_id',{rules: [
                    { required: false, message: '请选择科室会会后调研' },
                  ],initialValue:data.after_survey_id}]"
                  placeholder="请选择科室会会后调研"
                  :disabled="isDisabled||reportDisabled"
                  @change="onChangeReport"
                >
                  <a-select-option
                    v-for="item in surveyData"
                    :key="item.id"
                    :value="item.id"
                  >
                    {{ item.name }}
                  </a-select-option>
                </a-select>
                <div
                  v-show="isReportError"
                  :class="{'has-explain':isReportError}"
                >
                  请选择科室会会后调研
                </div>
              </div>
            </a-radio>
            <a-radio :value="2">
              <div class="meeting-text">
                科室会会后试卷
              </div>
              <div
                class="meeting-select"
                :class="{'has-error':isPaperError}"
              >
                <a-select
                  v-decorator="['paper_id',{rules: [
                    { required: false, message: '请选择科室会会后试卷' },
                  ],initialValue:data.paper_id}]"
                  placeholder="请选择科室会会后试卷"
                  :disabled="isDisabled||paperDisabled"
                  @change="onChangeReport"
                >
                  <a-select-option
                    v-for="item in paperData"
                    :key="item.id"
                    :value="item.id"
                  >
                    {{ item.name }}
                  </a-select-option>
                </a-select>
                <div
                  v-show="isPaperError"
                  :class="{'has-explain':isPaperError} "
                >
                  请选择科室会会后试卷
                </div>
              </div>
            </a-radio>
            <div v-show="!paperDisabled">
              <div class="meeting-text time-text">
                参会时长要求
              </div>
              <div class="meeting-select time-select">
                <a-input-number
                  v-decorator="['stop_time',{rules: [
                    { required: !paperDisabled, message: '请输入参会时长' },
                  ],initialValue:data.stop_time}]"
                  placeholder="请输入参会时长"
                  class="time-input"
                  :disabled="isDisabled"
                  :min="0"
                  :formatter="value => `${value}分钟`"
                />
                <span class="time-tip">0 为无要求</span>
              </div>
            </div>
          </a-radio-group>
        </template>
        <template #time>
          <a-range-picker
            v-decorator="['time',{rules: [
              { required: true, message: '请选择时间' },

            ],initialValue:data.time}]"
            show-time
          />
        </template>
        <template #require_desc>
          <a-textarea
            v-decorator="['require_desc',{rules: [
              { required: true, message: '请输入任务要求' },

            ],initialValue:data.require_desc}]"
            :rows="2"
            placeholder="请输入任务要求"
          />
        </template>
      </basic-form>
      <div class="btn-wrapper">
        <div class="require-tip">
          <span style="color:#f5222d">*</span>的为必填，其他若无可不填
        </div>
        <div class="btn-container">
          <a-button @click="onCancel">
            返回
          </a-button>
          <a-button
            :loading="btnIsLoading"
            type="primary"
            style="margin-left:20px;"
            @click="handleSubmit"
          >
            提交
          </a-button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { formData } from './../data/index';
export default {
  data() {
    return {
      formData: [...formData],
      typeData: [
        { id: 1, name: '线上拜访' },
        { id: 2, name: '学术调研' },
        { id: 3, name: '科室会通知' },
        { id: 4, name: '沙龙会' },
        { id: 5, name: '科室会邀请讲课' },
      ],
      companyData: [],
      promotersData: [{ key: 0, value: 0, title: '全部', children: [] }],
      resourceData: [],
      surveyData: [],
      adminData: [],
      loading: false,
      btnIsLoading: false,
      isDisabled: true,
      isDisabledPromoter: true,
      data: { task_type: 1, require_desc: '请在任务时限内进行推广', stop_time: 0 },
      isCompanyDisabled: false,
      companyId: '',
      paperData: [],
      task_type: 1,
      disabledTaskType: false,
      selectMode: 'multiple',
      reportDisabled: true,
      paperDisabled: true,
      meet: 0,
      isPaperError: false,
      isReportError: false,
    };
  },
  async mounted() {
    // 获取药企
    await this.getCompanyData();
    // 回显
    if (this.$route.query.id) {
      this.isCompanyDisabled = true;
      this.isDisabled = false;
      this.isDisabledPromoter = false;
      let id = this.$route.query.id;
      this.disabledTaskType=true;
      await this.getData({ id });
    }
  },
  methods: {
    // 回显
    async getData(params) {
      let result = await this.$http.post('/task/info', params);
      if (result.data.status === 1) {
        let temp = result.data.data;
        this.companyId = temp.info.company_id;
        this.data.paper_id=temp.info.paper_id?temp.info.paper_id:undefined;
        this.data.after_survey_id=temp.info.after_survey_id?temp.info.after_survey_id:undefined;
        this.reportDisabled=temp.info.after_survey_id?false:true;
        this.task_type=temp.info.task_type;
        // 学术调研  单选
        if(temp.info.task_type===2){
          this.selectMode= 'default';
        }else{
          this.selectMode= 'multiple';
        }
        await this.getAdminData({
          platform_type: 'cp',
          company_id: temp.info.company_id,
        });
        await this.getPromoterData({
          drug_type: '0',
          company_id: temp.info.company_id,
          admin_id: temp.info.admin_id,
        });
        await this.getResourceData({
          polymorphic_type: '1',
          company_id: temp.info.company_id,
          obj_type: '0',
        });
        await this.getPaperData({
          company_id: temp.info.company_id,
          use_type: temp.info.task_type,
        });
        await this.getSurveyData({
          polymorphic_type: '1',
          company_id: temp.info.company_id,
        });
        if(temp.info.task_type===2){
          let data=['meet'];
          let temp=[];
          data.forEach((item)=>{
            this.formData.forEach((option, index)=>{
              if(option.name ===item){
                this.formData.splice(index, 1);
              }
            }
            );
          });
        }
        // 主讲人
        if (temp.info.task_type === 3 || temp.info.task_type === 4) {
          this.formData.splice(2, 0, {
            name: 'task_speaker',
            lable: '主讲人',
            lableCol: 6,
            wrapperCol: 12,
            offset: 0,
            span: 24,
          });
          this.formData.push(
            {
              name: 'meet',
              lable: '会议其他要求',
              lableCol: 6,
              wrapperCol: 12,
              offset: 0,
              span: 24,
            },
          );
        }
        // 回显  获取已选择资料
        let result1 = await this.$http.post('/task/getTaskDatas', {
          task_id: this.$route.query.id,
        });
        if (result1.data.status === 1) {
          this.data = temp.info;
          this.data.promoters = temp.promoter_list.map(
            (item) => item.promoter_id
          );
          this.data.time = [
            this.$Moment(temp.info.start_time),
            this.$Moment(temp.info.end_time),
          ];
          this.data.paper_id=temp.info.paper_id?temp.info.paper_id:undefined;
          this.data.after_survey_id=temp.info.after_survey_id?temp.info.after_survey_id:undefined;
          if (!temp.info.after_survey_id && !temp.info.paper_id) {
            this.reportDisabled = true;
            this.paperDisabled = true;
            this.meet =0;
          }
          if (temp.info.after_survey_id) {
            this.reportDisabled = false;
            this.paperDisabled = true;
            this.meet = 1;
          }
          if (temp.info.paper_id) {
            this.reportDisabled = true;
            this.paperDisabled = false;
            this.meet = 2;
          }

          let data1 = result1.data.data.data_list;
          let datas;
          if(temp.info.task_type===2){
            datas=JSON.stringify({post_id: data1[0].post_id, obj_type: data1[0].obj_type});
          }else{
            datas=data1.map((item)=>{return JSON.stringify({post_id: item.post_id, obj_type: item.obj_type});});
          }
          this.data.datas =datas;
          console.log('getData ->  this.data', this.data);
        }
      }
    },
    // 获取已选择资料
    async checkResource(record) {
      let result = await this.$http.post('/task/getTaskDatas', {
        task_id: record.id,
      });
      if (result.data.status === 1) {
        let data = result.data.data.data_list;
        this.resourceData = data;
      }
    },
    // 获取药企
    async getCompanyData() {
      let result = await this.$http.post('/company/getCompanyList');
      if (result.data.status === 1) {
        let data = result.data.data.data_list.map((item) => {
          return {
            name: item.team_name
              ? item.team_name
              : item.companyInfo.qichacha_name,
            ...item,
          };
        });
        this.companyData = [...this.companyData, ...data];
      }
    },
    // 获取发布者
    async getAdminData(params) {
      let result = await this.$http.post('/managerMg/getDataList', params);
      if (result.data.status === 1) {
        let data = result.data.data.data_list;
        this.adminData = data;
      }
    },
    // 获取推广员
    async getPromoterData(params) {
      let result = await this.$http.post('/task/addTaskGetPromoters', params);
      if (result.data.status === 1) {
        let data = result.data.data.data_list;
        data.forEach((item) => {
          item.title = item.user_realname;
          item.key = item.promoter_id;
          item.value = item.promoter_id;
        });
        this.promotersData[0].children = data;
        console.log(
          'getPromoterData -> this.promotersData',
          this.promotersData
        );
      }
    },
    // 获取药企资料(素材)
    async getResourceData(params) {
      let result = await this.$http.post('/portalPost/getDatas', params);
      if (result.data.status === 1) {

        let temp=result.data.data.data_list;
        let data=[];
        if(this.task_type===2){
          data=temp.filter((item)=>item.obj_type===3);
          console.log('data', data);
        }else{
          data=temp.filter((item)=>item.obj_type!==3);
          console.log('data', data);
        }
        this.resourceData = JSON.parse(JSON.stringify(data)).map((item)=>{return {id: JSON.stringify({post_id: item.id, obj_type: item.obj_type}), name: `【${item.obj_type_name}】${item.name}`};});
        console.log('getResourceData -> this.resourceData', this.resourceData);
      }
    },
    // 搜索药企资料
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    // 获取反馈资料(会后调研)
    async getSurveyData(params) {
      let result = await this.$http.post('/portalPost/getQuestionnaires', params);
      if (result.data.status === 1) {
        let data = result.data.data.data_list;
        this.surveyData =[...data];
      }
    },
    // 获取试卷
    async getPaperData(params) {
      let result = await this.$http.post('/paper/getDrugPaperList', params);
      if (result.data.status === 1) {
        let data = result.data.data.data_list;
        this.paperData = data;
      }
    },
    // 选择药企
    handleChangeCompany(id) {
      this.isDisabled = false;
      this.isDisabledPromoter = true;
      this.companyId = id;
      this.getAdminData({ platform_type: 'cp', company_id: id });
      this.getResourceData({
        polymorphic_type: '1',
        company_id: id,
        obj_type: '0',
      });
      this.getSurveyData({ polymorphic_type: '1', company_id: id });
      this.$refs.basicForm.form.setFieldsValue({
        admin_id: undefined,
        promoters: undefined,
        after_survey_id: undefined,
        datas: undefined,
        paper_id: undefined,
      });
      this.getPaperData({
        company_id: this.companyId,
        use_type: this.task_type,
      });
    },
    // 选择发布者
    async changeAdmin(admin) {
      this.isDisabledPromoter = false;
      this.getPromoterData({
        drug_type: '0',
        company_id: this.companyId,
        admin_id: admin,
      });
      this.$refs.basicForm.form.setFieldsValue({ promoters: undefined });
    },
    // 选择任务类型
    changeTaskType(e) {
      let value=e.target.value;
      this.$refs.basicForm.form.resetFields();
      this.task_type = value;
      this.$refs.basicForm.form.setFieldsValue({
        datas: undefined,
      });
      this.companyId&&this.getPaperData({
        company_id: this.companyId,
        use_type: this.task_type,
      });
      this.companyId&&this.getResourceData({
        polymorphic_type: '1',
        company_id: this.companyId,
        obj_type: '0',
      });
      if(value===2){
        this.selectMode='default';
      }else{
        this.selectMode='multiple';
      }
      if(value===2||value===1||value===5){
        let data=['meet'];
        data.forEach((item)=>{
          this.formData.forEach((option, index)=>{
            if(option.name ===item){
              this.formData.splice(index, 1);
            }
          }
          );
        });
      }else{
        if(!this.formData.find((item)=>item.name==='meet')){
          this.formData.push(
            {
              name: 'meet',
              lable: '会议其他要求',
              lableCol: 6,
              wrapperCol: 12,
              offset: 0,
              span: 24,
            },
          );
        }
      }
      if (value === 3 || value === 4) {
        let data = {
          name: 'task_speaker',
          lable: '主讲人',
          lableCol: 6,
          wrapperCol: 12,
          offset: 0,
          span: 24,
        };
        console.log('changeTaskType -> this.formData', this.formData);
        if (!this.formData.find((item) => item.name === 'task_speaker')) {
          this.formData.splice(2, 0, data);
        }
      } else {
        this.formData = this.formData.filter((item) => {
          return item.name !== 'task_speaker';
        });
        console.log('changeTaskType -> this.formData2', this.formData);
      }

    },
    // 选择素材
    onChangeResource(val){
      let value;
      if(Array.isArray(val)){
        value=val[0];
      }else{
        value=val;
      }
      let temp=this.resourceData.find(((item)=>item.id===value)).name;
      this.$refs.basicForm.form.setFieldsValue({'task_name': temp});
    },
    // 选择会后调研 或者会后试卷
    onChangeReport(){
      this.isReportError=false;
      this.isPaperError=false;
    },
    // 选择科室会会后资料
    onChangeMeet(e) {
      let value = e.target.value;
      console.log('onChangeMeet -> value', value);
      if (value === 0) {
        this.reportDisabled = true;
        this.paperDisabled = true;
        this.isReportError=false;
        this.isPaperError=false;
      }
      if (value === 1) {
        this.reportDisabled = false;
        this.paperDisabled = true;
        this.isReportError=false;
        this.isPaperError=false;
      }
      if (value === 2) {
        this.reportDisabled = true;
        this.paperDisabled = false;
        this.isReportError=false;
        this.isPaperError=false;
      }
      this.$refs.basicForm.form.setFieldsValue({
        paper_id: undefined,
        after_survey_id: undefined,
      });
    },
    // 提交
    handleSubmit() {
      this.$refs.basicForm.form.validateFields(async(err, values) => {
        console.log('TCL: handleSubmit -> values', values);
        if(values.meet===1){
          if(!values.after_survey_id){
            this.isReportError=true;
          }
        }
        if(values.meet===2){
          if(!values.paper_id){
            this.isPaperError=true;
          }
        }
        if (!err&&!this.isReportError&&!this.isPaperError) {
          if (this.$route.query) {
            this.id = this.$route.query.id;
          }
          let datas=[];
          if(Array.isArray(values.datas)){
            datas= values.datas.map((item)=>JSON.parse(item));
          }else{
            datas.push(JSON.parse(values.datas));
          }
          let data = {
            id: this.id ? this.id : undefined,
            polymorphic_type: 0,
            company_id: values.company_id,
            task_name: values.task_name,
            task_type: values.task_type,
            admin_id: values.admin_id,
            task_speaker: values.task_speaker,
            name: values.name,
            promoters: values.promoters.join(),
            datas: datas,
            after_survey_id: values.after_survey_id||'',
            paper_id: values.paper_id||'',
            stop_time: values.stop_time,
            score: values.score,
            service_price: values.service_price,
            start_time: values.time[0].format('YYYY-MM-DD HH:mm:ss'),
            end_time: values.time[1].format('YYYY-MM-DD HH:mm:ss'),
            content: '',
            require_desc: values.require_desc,
          };
          this.btnIsLoading = true;
          let result = await this.$http.post('/task/update', data);
          this.btnIsLoading = false;
          if (result.data.status === 1) {
            this.$message.success('操作成功！');
            this.$router.back();
          }
        }
      });
    },
    // 返回
    onCancel() {
      this.$router.back();
    },
  },
};
</script>
<style scoped lang="scss">
.article-edit-container {
  /deep/ .ant-form-item-no-colon {
    .ant-form-item-label {
      text-align: right;
      .ant-form-item-required {
        &::before {
          display: inline-block;
          content: "*";
          color: #f5222d;
          font-size: 14px;
          line-height: 1;
        }
        &::after {
          content: "";
        }
      }
    }
  }
  .content {
    &::before {
      display: inline-block;
      content: "*";
      color: #f5222d;
      font-size: 14px;
      line-height: 1;
      position: absolute;
      left: -48px;
      top: 15px;
    }
  }
  .content-error {
    color: #f5222d;
  }

  .ant-input-number {
    width: 100%;
  }
  .btn-wrapper {
  }
  .btn-container {
    text-align: right;
    margin-top: 100px;
    width: 80%;
    display: inline-block;
  }
  .require-tip {
    text-align: left;
    width: 20%;
    display: inline-block;
  }
  .time-input {
    width: 60%;
  }
  .time-tip {
    width: 18%;
    padding-left: 5px;
    font-size: 14px;
    color: #ccc;
  }
  /deep/ .ant-select-search__field__wrap {
    .ant-select-search__field {
      min-width: 6px !important;
    }
  }
   .meeting{
     width: 100%;
    /deep/ .ant-radio-wrapper{
      width: 100%;
      margin-bottom: 20px;
    }
    .meeting-text {
      display: inline-block;
      width: 120px;
    }
    .time-text {
      padding-left: 20px;
    }
    .meeting-select {
      display: inline-block;
      width: calc(100% - 136px);
    }
    .time-select {
padding-left: 24px;
    }
    .has-error{
      border-color: #f5222d;
    }
    .has-explain{
      color: #f5222d;
     position: absolute;
    }

  }
}
</style>